import { Alert, NotificationChannel } from "../types/alerts";

export const mockChannels: NotificationChannel[] = [
  {
    id: "channel-001",
    name: "Security Team Email",
    type: "email",
    enabled: true,
    config: {
      email: "security@earlycore.com",
    },
  },
  {
    id: "channel-002",
    name: "AI Operations Slack",
    type: "slack",
    enabled: true,
    config: {
      slackChannel: "#ai-ops-alerts",
    },
  },
  {
    id: "channel-003",
    name: "Critical Issues Webhook",
    type: "webhook",
    enabled: true,
    config: {
      webhookUrl: "https://hooks.example.com/earlycore/alerts",
    },
  },
  {
    id: "channel-004",
    name: "On-Call PagerDuty",
    type: "pagerduty",
    enabled: false,
    config: {
      serviceKey: "pagerduty-service-key",
    },
  },
];

export const mockAlerts: Alert[] = [
  {
    id: "alert-001",
    name: "Critical PII Detection Alert",
    description: "Alert when PII detection scanner finds critical issues",
    query: "Alert me when there are critical PII detection issues from any AI agent",
    category: "PRIVACY_VIOLATION",
    priority: "P0",
    frequency: "every 5 minutes",
    timeWindow: "the last 15 minutes",
    condition: "the query has any results",
    channels: ["channel-001", "channel-002"],
    status: "ACTIVE",
    lastTriggered: "2025-10-15T10:23:45Z",
    triggerCount: 12,
    createdAt: "2025-10-01T08:00:00Z",
    updatedAt: "2025-10-15T09:30:00Z",
    createdBy: "user@earlycore.com",
  },
  {
    id: "alert-002",
    name: "High Error Rate on AI Agents",
    query: "Notify me when the error rate for any AI agent exceeds 5% in the last hour",
    category: "PERFORMANCE",
    priority: "P1",
    frequency: "every 15 minutes",
    timeWindow: "the last hour",
    condition: "the error rate exceeds X%",
    conditionValue: 5,
    channels: ["channel-002", "channel-003"],
    status: "ACTIVE",
    lastTriggered: "2025-10-15T09:45:30Z",
    triggerCount: 3,
    createdAt: "2025-10-05T10:00:00Z",
    updatedAt: "2025-10-14T15:20:00Z",
    createdBy: "user@earlycore.com",
  },
  {
    id: "alert-003",
    name: "Prompt Injection Attack Detected",
    query: "Alert when prompt injection scanner detects high or critical severity issues",
    category: "SECURITY_INCIDENT",
    priority: "P0",
    frequency: "every minute",
    timeWindow: "the last 5 minutes",
    condition: "the query has any results",
    channels: ["channel-001", "channel-002", "channel-004"],
    status: "ACTIVE",
    lastTriggered: "2025-10-15T08:30:15Z",
    triggerCount: 28,
    createdAt: "2025-09-20T12:00:00Z",
    updatedAt: "2025-10-10T14:00:00Z",
    createdBy: "user@earlycore.com",
  },
  {
    id: "alert-004",
    name: "Model Token Usage Spike",
    query: "Alert me when any AI model's token usage exceeds 3x the baseline",
    category: "PERFORMANCE",
    priority: "P2",
    frequency: "every hour",
    timeWindow: "the last 6 hours",
    condition: "the query returns more than X% of baseline",
    conditionValue: 300,
    channels: ["channel-002"],
    status: "ACTIVE",
    lastTriggered: undefined,
    triggerCount: 0,
    createdAt: "2025-10-12T09:00:00Z",
    updatedAt: "2025-10-12T09:00:00Z",
    createdBy: "user@earlycore.com",
  },
  {
    id: "alert-005",
    name: "Data Exfiltration Attempt",
    query: "Notify me when data exfiltration scanner finds any issues",
    category: "DATA_EXFILTRATION",
    priority: "P0",
    frequency: "every 5 minutes",
    timeWindow: "the last 15 minutes",
    condition: "the query has any results",
    channels: ["channel-003"],
    status: "PAUSED",
    lastTriggered: "2025-10-14T16:00:00Z",
    triggerCount: 5,
    createdAt: "2025-09-15T11:00:00Z",
    updatedAt: "2025-10-14T16:30:00Z",
    createdBy: "user@earlycore.com",
  },
  {
    id: "alert-006",
    name: "Multiple Critical Issues in Short Time",
    query: "Alert when there are more than 10 critical security issues from any agent in the last hour",
    category: "SECURITY_INCIDENT",
    priority: "P1",
    frequency: "every 15 minutes",
    timeWindow: "the last hour",
    condition: "the query returns X or more rows",
    conditionValue: 10,
    channels: ["channel-001", "channel-004"],
    status: "ACTIVE",
    lastTriggered: "2025-10-15T07:00:00Z",
    triggerCount: 1,
    createdAt: "2025-10-08T13:00:00Z",
    updatedAt: "2025-10-08T13:00:00Z",
    createdBy: "user@earlycore.com",
  },
];
